export default __webpack_public_path__ + "static/media/delivery-truck.01df9efb.svg";